<template>
  <SidebarLayout storage-key="settings-rail-expanded">
    <template #sidebar="{ isExpanded, toggleExpanded }">
      <SettingsRail :is-expanded="isExpanded" class="z-60" @nav-item-clicked="toggleExpanded" />
    </template>
    <template #app-bar="{ isExpanded, toggleExpanded }">
      <AppBar
        :is-expanded="isExpanded"
        hide-settings
        class="z-40"
        @toggle-menu="toggleExpanded"
      />
    </template>
    <slot />
  </SidebarLayout>
</template>

<script setup lang="ts">
  import AppBar from '../sidebar/AppBar.vue'
  import SettingsRail from '../sidebar/SettingsRail.vue'
  import SidebarLayout from './SidebarLayout.vue'
</script>
